module.exports = __webpack_public_path__ + "static/media/soc-ig-white.0e45c0ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soc/soc-ig-white.svg
// module id = 934
// module chunks = 270